<template>
    <div>
        <v-layout row wrap justify-center>
              <v-flex xs12 sm7 md7 >
                  <dialogos-app :dialogos="dialogosRegion" tucan="0" @update:currentText="currentText = $event"></dialogos-app>
              </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center mt-4 :class="{'noclick':noclick}">
            <v-flex xs12 sm7 md12 class="cont-img" v-for="n in 2" :key="n">
                <div class="contenedor">
                    <img class="hvr" :class="activebtn[n-1] ? 'active':''" 
                    :src="require('@/assets/presentacion/diap-4-'+n+'.png')" alt="" 
                    @click="openmodaltext(n)">
                </div>
            </v-flex>
        </v-layout>  
              <!-- MODAL DE LAS REGIONES -->
        <modal-app v-model="modaltext" :fullscreen="false">
            <template slot="modaltittle">
                <h1 class="modal-icon-title"></h1>
            </template>
            <v-layout justify-center wrap>
                <v-flex xs12 sm7 md7>
                    <p class="animated fadeIn">{{texto[numtext]}}</p>
                </v-flex>
            </v-layout>
        </modal-app> 
    </div>
</template>

<script>
export default {
    data(){
        return {
            dialogosRegion:[
                'A Região Norte está dividida em 7 estados: Acre, Amapá, Amazonas, Pará, Rondônia, Roraima e Tocantins.',
                'Clique nas imagens e conheça um pouco do patrimônio do Amazonas.'
            ],
            currentText:0,
            numImg:1,
            texto:[
                'O Arena da Amazônia é um estádio localizado na cidade de Manaus, capital do estado do Amazonas.',
                'O Teatro Amazonas, construído em 1896, é um teatro de ópera que se encontra em Manaus.' 
            ],
            modaltext:false,
            numtext:0,
            activebtn:Array(2).fill(false),
            noclick:true
        }
    },
    methods: {
        openmodaltext(val){
            this.modaltext = true
            this.numtext = val-1
            this.$set(this.activebtn,val-1,true)

        }
    },
    watch: {
        currentText(val){
            this.noclick = false
        }
    },
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../../../sass/globals';

.active{
    box-shadow: 0 0 10px black;
    filter: grayscale(0)!important;
}
.noclick{
  pointer-events: none;
  opacity: 0.4!important;
}
.contenedor{
    width: 100%;
    height: 140px;
    overflow: hidden;
    display: flex;
    position: relative;
    margin: 0 auto;
    margin-bottom: 10px;
    justify-content: center;
    align-items: center;
    img{
        filter: grayscale(1);
    }
}
</style>
